<template>
  <div class="agricultural_machinery">
    <div class="zhilian">
      <div class="item">
        <div class="item_title">
          <p>
            <img src="../../../../static/img/icon3.png" alt="">
            <img src="../../../../static/img/icon2.png" alt="">
            <img src="../../../../static/img/icon1.png" alt="">
          </p>
          <span class="tit_class">累计作业面积
          	<!--<img src="../../../../static/img/zhiliannongji-right-icon.png" alt="">-->
          </span>
        </div>
        <p class="img_right2"><span>单位：亩次</span></p>
      </div>
      <div id='workingAreaEchart' style="width:99%;height:23vh;"></div>
      <div class="work_area">
        <p>总面积：<span>{{ statisticsUserSum }}</span>亩次</p>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../../Serves/net-api.js'
import Http from '../../../Serves/net-http.js'
import {mapState,mapActions,mapMutations} from "vuex";
var timer;
export default {
  components:{
    
  },
  data(){
    return{
      workingAreaEchart: '',
      statisticsUserSum: 0,
      AreaByWorkSum: '',
      getDataArr: [],
      statisticsUserData: [],
      countNjUser: '',
      statisticsUser: '',
      sumAreaByWork: '',
      charPieCurrentIndex: 0,
      isSet: true
    }
  },
  mounted(){
    setTimeout(() => {
      this.getStatisticsUserData()
    }, 100)
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.workingAreaEchart.resize()
      })
    })
    // setTimeout(this.startTimer, 500);
  },
  methods:{
    // 农机用户
    getStatisticsUserData () {
      var url=Http.test+'/homePageStatis/countWorkAreaByCategory'
      Api.doPost(url,null,false,(res)=>{
        this.getDataArr = res.result
        for (var i in res.result) {
          this.statisticsUserSum += res.result[i].workArea
        }
        this.statisticsUserData = res.result.map(item => {
          return {
            name: item.catThreeName,
            value: item.workArea
          }
        })
        
        this.bus.$emit('statisticsUserSum', this.statisticsUserSum);
        this.getDataEchart1()
      })
    },
    getDataEchart1 () {
      this.workingAreaEchart=this.$echarts.init(document.getElementById('workingAreaEchart'))
      var colorLine = ['#007AFF','#01D0E1', '#00C800', '#F7C80B', '#7C00FF', '#FECE43','#007aff','#00c800','#ff7200']
      function getRich() {
        let result = {}
        colorLine.forEach((v, i) => {
          result[`hr${i}`] = {
            backgroundColor: colorLine[i],
            borderRadius: 3,
            width: 3,
            height: 3,
            padding: [3, 3, 0, -12]
          }
          result[`a${i}`] = {
            padding: [2, -20, -20, -20],
            color: colorLine[i],
            fontSize: 12
          }
        })
        return result
      }
      // 初始
      this.workingAreaEchart.setOption({
        title: {
          text: '',
          // top: 20,
          textStyle: {
            color: '#fff',
            fontSize: 12,
            fontWeight:'400',
          },
          subtext: '',
          subtextStyle: {
            color: '#fff',
            fontSize: 16,
            fontWeight:'100',
          },
          itemGap: 10,
          left: 'center',
          top: '35%'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false,
          itemWidth: 13,
          itemHeight: 13,
          icon: "rect",
          itemGap: 10 ,
          // type: 'plain',
          orient: 'vertical',
          left: '50%',
          top: '25%',
          textStyle: {
            fontSize: 14,
            color: '#668eb9'
          },
          formatter: function(value) {
            return value + '：2000个'
          }
        },
        series: [{
          type: 'pie',
          center: ['50%', '43%'],
          radius: ['80%', '55%'],
          // clockwise: true,
          // avoidLabelOverlap: true,
          // hoverOffset: 100,
          color: ['#007AFF','#01D0E1', '#00C800', '#F7C80B', '#7C00FF', '#FECE43','#007aff','#00c800','#ff7200'],
          label: {
            show: false,
            position: 'outside',
            formatter: '{d}%',
            fontSize: 14,
            rich: {
              hr: {
                backgroundColor: 't',
                borderRadius: 3,
                width: 3,
                height: 3,
                padding: [3, 3, 0, -12]
              },
              a: {
                padding: [-30, 15, -20, 15]
              }
            }
          },
          // label: {
          //   show: true,
          //   position: 'outside',
          //   formatter: function(params) {
          //     const name = params.name
          //     const percent = params.percent + '%'
          //     const index = params.dataIndex
          //     return [`{a${index}|${percent}}`, `{hr${index}|}`].join('\n')
          //   },
          //   rich: getRich()
          // },
          labelLine: {
            normal: {
              length: 20,
              length2: 30,
              lineStyle: {
                width: 1
              }
            }
          },
          // roseType: 'radius',
          data: this.statisticsUserData
        }]
      })
      if (this.statisticsUserData.length !== 0) {
        timer = setInterval(this.chartHover, 2000)
      }
      // 鼠标移入
      this.workingAreaEchart.on("mouseover", (e) => {
        let option = this.workingAreaEchart.getOption();
        this.workingAreaEchart.setOption({
          title: {
            text: e.name,
            // top: 20,
            textStyle: {
              color: option.series[0].color[e.dataIndex],
              fontSize: 12,
              fontWeight:'400',
            },
            subtext: e.value,
            subtextStyle: {
              color: '#fff',
              fontSize: 16,
              fontWeight:'100',
            },
            itemGap: 10,
            left: 'center',
            top: '37%'
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            show: false,
            itemWidth: 13,
            itemHeight: 13,
            icon: "rect",
            itemGap: 10 ,
            // type: 'plain',
            orient: 'vertical',
            left: '50%',
            top: '25%',
            textStyle: {
              fontSize: 14,
              color: '#668eb9'
            },
            formatter: function(value) {
              return value + '：2000个'
            }
          },
          series: [{
            type: 'pie',
            center: ['50%', '43%'],
            radius: ['80%', '55%'],
            // clockwise: true,
            // avoidLabelOverlap: true,
            // hoverOffset: 15,
            color: ['#007AFF','#01D0E1', '#00C800', '#F7C80B', '#7C00FF', '#FECE43','#007aff','#00c800','#ff7200'],
            label: {
              show: false,
              position: 'outside',
              formatter: '{d}%',
              fontSize: 14,
              rich: {
                hr: {
                  backgroundColor: 't',
                  borderRadius: 3,
                  width: 3,
                  height: 3,
                  padding: [3, 3, 0, -12]
                },
                a: {
                  padding: [-30, 15, -20, 15]
                }
              }
            },
            // label: {
            //   show: true,
            //   position: 'outside',
            //   formatter: function(params) {
            //     const name = params.name
            //     const percent = params.percent + '%'
            //     const index = params.dataIndex
            //     return [`{a${index}|${percent}}`, `{hr${index}|}`].join('\n')
            //   },
            //   rich: getRich()
            // },
            labelLine: {
              normal: {
                length: 20,
                length2: 30,
                lineStyle: {
                  width: 1
                }
              }
            },
            // roseType: 'radius',
            data: this.statisticsUserData
          }]
        })
        this.isSet = false
        clearInterval(timer)
        // 取消之前高亮的图形
        // this.workingAreaEchart.dispatchAction({
        //   type: 'downplay',
        //   seriesIndex: 0,
        //   dataIndex: this.charPieCurrentIndex
        // })
        // // 高亮当前图形
        // this.workingAreaEchart.dispatchAction({
        //   type: 'highlight',
        //   seriesIndex: 0,
        //   dataIndex: e.dataIndex
        // })
        // // 显示 tooltip
        // this.workingAreaEchart.dispatchAction({
        //   type: 'showTip',
        //   seriesIndex: 0,
        //   dataIndex: e.dataIndex
        // })
      })
      // 鼠标移出
      this.workingAreaEchart.on("mouseout", (e) => {
        if (!this.isSet) {
          timer = setInterval(this.chartHover, 2000)
          this.isSet = true
        }
      })
    },
    chartHover () {
      let option = this.workingAreaEchart.getOption();
      var dataLen = option.series[0].data.length
      this.workingAreaEchart.setOption({
        title: {
          text: this.statisticsUserData[this.charPieCurrentIndex].name,
          // top: 20,
          textStyle: {
            color: option.series[0].color[this.charPieCurrentIndex],
            fontSize: 12,
            fontWeight:'400',
          },
          subtext: this.statisticsUserData[this.charPieCurrentIndex].value,
          subtextStyle: {
            color: '#fff',
            fontSize: 16,
            fontWeight:'100',
          },
          itemGap: 10,
          left: 'center',
          top: '35%'
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          show: false,
          itemWidth: 13,
          itemHeight: 13,
          icon: "rect",
          itemGap: 10 ,
          // type: 'plain',
          orient: 'vertical',
          left: '50%',
          top: '25%',
          textStyle: {
            fontSize: 14,
            color: '#668eb9'
          },
          formatter: function(value) {
            return value + '：2000个'
          }
        },
        series: [{
          type: 'pie',
          center: ['50%', '43%'],
          radius: ['80%', '55%'],
          clockwise: true,
          avoidLabelOverlap: true,
          // hoverOffset: 15,
          color: ['#007AFF','#01D0E1', '#00C800', '#F7C80B', '#7C00FF', '#FECE43','#007aff','#00c800','#ff7200'],
          label: {
            show: false,
            position: 'outside',
            formatter: '{d}%',
            fontSize: 14,
            rich: {
              hr: {
                backgroundColor: 't',
                borderRadius: 3,
                width: 3,
                height: 3,
                padding: [3, 3, 0, -12]
              },
              a: {
                padding: [-30, 15, -20, 15]
              }
            }
          },
          labelLine: {
            normal: {
              length: 20,
              length2: 30,
              lineStyle: {
                width: 1
              }
            }
          },
          // roseType: 'radius',
          data: this.statisticsUserData
        }]
      })
      // 取消之前高亮的图形
      // this.workingAreaEchart.dispatchAction({
      //   type: 'downplay',
      //   seriesIndex: 0,
      //   dataIndex: this.charPieCurrentIndex
      // })
      // // 显示 tooltip
      // this.workingAreaEchart.dispatchAction({
      //   type: 'showTip',
      //   seriesIndex: 0,
      //   dataIndex: this.charPieCurrentIndex
      // })
      // // 高亮当前图形
      // this.workingAreaEchart.dispatchAction({
      //   type: 'highlight',
      //   seriesIndex: 0,
      //   dataIndex: this.charPieCurrentIndex
      // })
      
      this.charPieCurrentIndex = (this.charPieCurrentIndex + 1) % dataLen 
    }
  }
}
</script>
<style scoped>
  .agricultural_machinery{
    width: 23%;
    height: 29vh;
    background-image: url(../../../../static/img/ng-left.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  p{
    color: #ccc;
  }
  .work_area{
    width: 100%;
    text-align: center;
    margin-top: -2.3vh;
  }
  .work_area p{
    font-size: 16px;
  }
  .item{
    height: 4.6vh;
    line-height: 4.6vh;
    display: flex;
    justify-content: space-between;
    padding: 0 1vw;
  }
  .item_title{
    display: flex;
  }
  .item_title p{
    margin-top: 0.2vh;
  }
 
  .item_title span{
    font-size: 0.9vw;
    font-weight: bold;
    color: #ffffff;
    font-family: '微软雅黑';
    margin-left: 0.5vw;
  }
  .tit_class{
    width: 83%;
  }
  .tit_class span{
    font-size: 20px;
  }
  .tit_class img{
    width: 55%;
  }
  .img_right2{
    width: 29%;
  }
  .img_right2 span{
    float: right;
    color: #81D4FF;
    font-size: 16px;
  }
  .img_right{
    width: 28%;
  }
  .img_right img{
    width: 100%;
    height: 0.5vw;
  }
  .zhilian{
    position: relative;
  }
  .statisticsUser{
    /* width: 50%; */
    position: absolute;
    left: 47%;
    top: 8.5vh;
    line-height: 2;
  }
  .statisticsUser p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .statisticsUser p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .statisticsUser p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .statisticsUser p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUser{
    position: absolute;
    left: 47%;
    top: 5vh;
    line-height: 2;
  }
  .countNjUser p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUser p:nth-child(1) span:nth-child(1), .sumAreaByWork p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(2) span:nth-child(1), .sumAreaByWork p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(3) span:nth-child(1), .sumAreaByWork p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(4) span:nth-child(1), .sumAreaByWork p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(5) span:nth-child(1), .sumAreaByWork p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(6) span:nth-child(1), .sumAreaByWork p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWork{
    position: absolute;
    left: 47%;
    top: 6.5vh;
    line-height: 2;
  }
  .sumAreaByWork p span:nth-child(2){
    font-size: 0.7vw;
  }

  .countNjUser2{
    position: absolute;
    left: 47%;
    top: 6.3vh;
    line-height: 2;
  }
  .countNjUser2 p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUser2 p:nth-child(1) span:nth-child(1), .sumAreaByWork2 p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(2) span:nth-child(1), .sumAreaByWork2 p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(3) span:nth-child(1), .sumAreaByWork2 p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(4) span:nth-child(1), .sumAreaByWork2 p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(5) span:nth-child(1), .sumAreaByWork2 p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(6) span:nth-child(1), .sumAreaByWork2 p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWork2{
    position: absolute;
    left: 47%;
    top: 8.5vh;
    line-height: 2;
  }
  .sumAreaByWork2 p span:nth-child(2){
    font-size: 0.7vw;
  }

  .countNjUserXM{
    position: absolute;
    left: 47%;
    top: 3.5vh;
    line-height: 2;
  }
  .countNjUserXM p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUserXM p:nth-child(1) span:nth-child(1), .sumAreaByWorkXM p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(2) span:nth-child(1), .sumAreaByWorkXM p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(3) span:nth-child(1), .sumAreaByWorkXM p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(4) span:nth-child(1), .sumAreaByWorkXM p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(5) span:nth-child(1), .sumAreaByWorkXM p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(6) span:nth-child(1), .sumAreaByWorkXM p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWorkXM{
    position: absolute;
    left: 47%;
    top: 5vh;
    line-height: 2;
  }
  .sumAreaByWorkXM p span:nth-child(2){
    font-size: 0.7vw;
  }
  
  .countNjUserXM p:nth-child(1) span:nth-child(1), .sumAreaByWorkGs p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(2) span:nth-child(1), .sumAreaByWorkGs p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(3) span:nth-child(1), .sumAreaByWorkGs p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(4) span:nth-child(1), .sumAreaByWorkGs p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(5) span:nth-child(1), .sumAreaByWorkGs p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(6) span:nth-child(1), .sumAreaByWorkGs p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWorkGs{
    position: absolute;
    left: 47%;
    top: 3.8vh;
    line-height: 2;
  }
  .sumAreaByWorkGs p span:nth-child(2){
    font-size: 0.7vw;
  }
</style>




// WEBPACK FOOTER //
// src/components/Index/view/SumWorkingArea.vue